"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferUpdatePositionOp = exports.PositionState = exports.IngredientStatus = exports.OfferStatus = void 0;
var OfferStatus;
(function (OfferStatus) {
    OfferStatus["Available"] = "available";
    OfferStatus["SoldOut"] = "soldout";
    OfferStatus["Paused"] = "paused";
    OfferStatus["Expired"] = "expired";
    OfferStatus["Unrecognized"] = "unrecognized";
})(OfferStatus || (exports.OfferStatus = OfferStatus = {}));
var IngredientStatus;
(function (IngredientStatus) {
    IngredientStatus["Verified"] = "verified";
    IngredientStatus["Pending"] = "pending";
})(IngredientStatus || (exports.IngredientStatus = IngredientStatus = {}));
var PositionState;
(function (PositionState) {
    PositionState["Created"] = "created";
    PositionState["Updated"] = "updated";
    PositionState["Deleted"] = "deleted";
    PositionState["Unrecognized"] = "unrecognized";
})(PositionState || (exports.PositionState = PositionState = {}));
var OfferUpdatePositionOp;
(function (OfferUpdatePositionOp) {
    OfferUpdatePositionOp["Add"] = "add";
    OfferUpdatePositionOp["Remove"] = "remove";
})(OfferUpdatePositionOp || (exports.OfferUpdatePositionOp = OfferUpdatePositionOp = {}));
